import { DisplayText } from "js/elements/elements/DisplayText";
import { HeaderPositionType } from "common/constants";

export class Header extends DisplayText {
    get textAlign() {
        return this.styles.textAlign || "center";
    }

    get singleLineHeadline() {
        return this.position === HeaderPositionType.TOP;
    }

    get position() {
        return this.model.headerPosition || this.canvas.model.layout.headerPosition;
    }

    get selectionPadding() {
        return 10;
    }

    get isResizable() {
        return true;
    }

    get fitToContents() {
        return {
            width: false,
            height: true
        };
    }

    get restrictResize() {
        return {
            width: false,
            height: true
        };
    }

    get needsFullSizeToCalcFit() {
        return {
            width: false,
            height: true
        };
    }

    _loadStyles(styles) {
        styles.applyStyles(styles._position[this.position]);
        if (this.canvas.getTheme().get("styleDecoration") === "bar_left" && this.canvas.model.layout.trayLayout === "left_tray") {
            styles.applyStyles({ decoration: null });
        }

        if (this.options.isOnAuthoringCanvas) {
            styles.marginBottom = 20;
        }
    }
}

export const elements = {
    Header
};
